<h4 class="mobile-nav-title" i18n>Customers</h4>
<div class="container-fluid">
  <a *ngIf="canAddCustomer" routerLink="/customer/add" class="btn btn-bidit-submit" i18n>Add Customer</a>

  <form class="row mt-2" (ngSubmit)="loadCustomers()">
    <div class="col-sm-3">
      <input name="customerName" id="customerName" class="form-control"
             type="text" placeholder="Search Customers" i18n-placeholder
             [(ngModel)]="filter.customerName" #customerName="ngModel" />
    </div>
    <div class="col-sm-3">
      <select name="customerType" id="customerType" class="form-control select-bidit"
              [(ngModel)]="filter.customerType" #customerType="ngModel">
        <option value="null" i18n>Select Customer Type</option>
        <option *ngFor="let customerType of summary?.customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="salespersonId" id="salespersonId" class="form-control select-bidit"
              [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
        <option value="" i18n>Select Salesperson</option>
        <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
      </select>
    </div>
    <div class="col-sm-3 mb-2 text-bidit-primary-header">
      <mat-checkbox id="showActive" name="showActive" [(ngModel)]="filter.showInactive" i18n>Show Inactive</mat-checkbox>
      <button type="submit" class="text-white float-right btn btn-bidit-navigate" i18n>Apply Filter</button>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
  <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
    <div *ngFor="let customer of customers">
      <div class="card bg-light border-bidit-dark mb-3 shadow">
        <div class="card-body">
          <div class="col">
            <a class="mobile-link" routerLink="/customer/{{customer.customer_ID}}">
              {{customer.customer_BusinessName}}
            </a>
          </div>
          <div class="col">
            <app-customer-info-summary-mobile [customerInfo]="customer"></app-customer-info-summary-mobile>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
